import { TApplicationState } from 'shared/types/redux';

export const gaLabelSelector = (state: TApplicationState) => {
  return state.newbuilding.gaLabel;
};
